import { toaster } from 'evergreen-ui';
import { useEffect, useMemo } from 'react';
import { useCan } from '../components/Can';
import { GET_ALL_REALMS_QUERY } from '../queries/getAllRealms';
import { SYSTEM_ADMIN } from '../utils/constants';
import { useGlobalStore } from './useGlobalStore';
import { useRealmScope } from './useRealmScope';
import { useLazyQuery } from '@apollo/client';

const GET_ALL_REALMS_ERROR_MESSAGE =
  'Sorry, something went wrong getting all realms data, please try again later.';

export function useSetRealmData() {
  const { userData, setRealmData, setRealmId } = useGlobalStore();
  const { realmId: scopedRealmId } = useRealmScope();

  const [getAllRealms, { loading: allRealmsLoading, data: allRealmsData }] =
    useLazyQuery(GET_ALL_REALMS_QUERY, {
      onError: (_) => toaster.danger(GET_ALL_REALMS_ERROR_MESSAGE),
    });
  const { verifyRoles } = useCan();

  const isSystemAdmin = verifyRoles(SYSTEM_ADMIN);

  useEffect(() => {
    /** call all the realms query if the user is admin */
    if (isSystemAdmin) {
      getAllRealms();
    }
  }, [isSystemAdmin, getAllRealms]);

  const assignedRealms = useMemo(
    () =>
      allRealmsData?.Realm ||
      userData?.Realm_Users?.map((realm) => realm.Realm),
    [userData, allRealmsData],
  );
  const realmsLoading = allRealmsLoading;

  useEffect(() => {
    /** set the realms options */
    const rawData =
      assignedRealms?.filter((item) => item.isBlocked === false) || [];
    setRealmData(rawData);
  }, [setRealmData, assignedRealms]);

  useEffect(() => {
    setRealmId(scopedRealmId);
  }, [scopedRealmId, setRealmId]);

  return { realmsData: assignedRealms, realmsLoading };
}
